import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3.80015 3.9998L13.4001 3.9998M13.4001 3.9998L10.2001 0.799805M13.4001 3.9998L10.2001 7.1998M10.2001 11.9998L0.600147 11.9998M0.600147 11.9998L3.80015 15.1998M0.600147 11.9998L3.80015 8.7998" />
  </svg>
);
